import { getMathematicalOperatorOptions } from '../logicHelpers'
import { scoresInFlow, inputQuestionsInFlow } from '@dashboard/modules/flow/builder/services/flowUtilities'
import { useFlowStore } from '@dashboard/modules/flow/stores/flowStore'
import { useQuestionStore } from '@dashboard/modules/segment/stores/questionStore'

const scoreSource = (context: { offerFunnelId?: string } = {}) => ({
  types: [
    { label: 'Lead Score', value: 'score', description: 'Points scored in this flow' },
    { label: 'Variable', value: 'variable', description: 'A value saved by a Set Data step' },
    { label: 'Input Question', value: 'inputQuestion', description: 'An answer given in this flow' }
    // {
    //   label: 'High Score',
    //   value: 'highScore'
    // },
    // {
    //   label: 'Low Score',
    //   value: 'lowScore'
    // }
  ],
  inputs: [
    {
      control: 'autocomplete',
      key: 'scores-score',
      name: 'score',
      options: () => {
        const offerFunnelId = context.offerFunnelId
        if (!offerFunnelId) {
          return []
        }
        const flowStore = useFlowStore()
        const questionStore = useQuestionStore()
        const flow = flowStore.getById(offerFunnelId)
        if (!flow) {
          return []
        }
        return scoresInFlow(flow.funnelDefinition, questionStore.questions).map((score) => ({
          label: score,
          value: score
        }))
      },
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'scores' && condition.$type === 'score'
    },
    {
      control: 'select',
      key: 'scores-operator-select',
      id: 'operator',
      name: 'operator',
      options: getMathematicalOperatorOptions(),
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'scores' && condition.$type === 'score'
    },
    {
      control: 'text',
      key: 'scores-value-input',
      name: 'value',
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'scores' && condition.$type === 'score'
    },
    {
      control: 'text',
      key: 'scores-variable-name',
      name: 'variableName',
      placeholder: 'last_offer_shown',
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'scores' && condition.$type === 'variable'
    },
    {
      control: 'select',
      key: 'scores-variable-operator-select',
      id: 'operator',
      name: 'operator',
      options: getMathematicalOperatorOptions(),
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'scores' && condition.$type === 'variable'
    },
    {
      control: 'text',
      key: 'scores-variable-value-input',
      name: 'value',
      can: (condition: { $source: string; $type: string; operator: string }) =>
        condition.$source === 'scores' &&
        condition.$type === 'variable' &&
        condition.operator !== 'is_set' &&
        condition.operator !== 'is_not_set'
    },
    {
      control: 'autocomplete',
      key: 'scores-input-question',
      name: 'questionId',
      options: () => {
        const offerFunnelId = context.offerFunnelId
        if (!offerFunnelId) {
          return []
        }
        const flowStore = useFlowStore()
        const questionStore = useQuestionStore()
        const flow = flowStore.getById(offerFunnelId)
        if (!flow) {
          return []
        }
        return inputQuestionsInFlow(flow.funnelDefinition, questionStore.questions).map((question) => ({
          label: question.label,
          value: question.id
        }))
      },
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'scores' && condition.$type === 'inputQuestion'
    },
    {
      control: 'select',
      key: 'scores-input-question-operator-select',
      id: 'operator',
      name: 'operator',
      options: getMathematicalOperatorOptions(),
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'scores' && condition.$type === 'inputQuestion'
    },
    {
      control: 'text',
      key: 'scores-input-question-value-input',
      name: 'value',
      can: (condition: { $source: string; $type: string; operator: string }) =>
        condition.$source === 'scores' &&
        condition.$type === 'inputQuestion' &&
        condition.operator !== 'is_set' &&
        condition.operator !== 'is_not_set'
    }
    // {
    //   control: 'text',
    //   key: 'jsdata-variable-input',
    //   name: 'variable',
    //   placeholder: 'mydata.industry',
    //   can: (condition: { $source: string; $type: string }) =>
    //     condition.$source === 'jsdata'
    // },
    // {
    //   control: 'select',
    //   key: 'jsdata-operator-select',
    //   id: 'operator',
    //   name: 'operator',
    //   options: getOperatorOptions(),
    //   can: (condition: { $source: string; $type: string }) =>
    //     condition.$source === 'jsdata'
    // },
    // {
    //   control: 'text',
    //   key: 'jsdata-value-input',
    //   name: 'value',
    //   can: (condition: {
    //     $source: string
    //     $type: string
    //     operator: string
    //   }) =>
    //     condition.$source === 'jsdata' &&
    //     condition.operator !== 'is set' &&
    //     condition.operator !== 'is not set'
    // }
  ]
})

export default scoreSource
